const CacheKeys = {
  Accounts: (userId) => {
    return `Accounts:${userId}`
  },

  Accounts: (userId, stp) => {
    return `Accounts:${userId}:${stp}`
  },

  AccountsFilter: () => {
    return `AccountsFilter`
  },

  Account: (accountId) => {
    return `Account:${accountId}`
  },

  AccountName: (accountId) => {
    return `AccountName:${accountId}`
  },

  AccountProperties: (accountId) => {
    return `AccountProperties:${accountId}`
  },

  AccountProperty: (accountId, propertyCode) => {
    return `AccountProperty:${accountId}:${propertyCode}`
  },

  AccountRepaymentsChecked: () => {
    return `AccountRepaymentsChecked`
  },

  AccountStats: (accountId) => {
    return `AccountStats:${accountId}`
  },

  AccountUsers: (accountId) => {
    return `AccountUsers:${accountId}`
  },

  AccountUsersFilter: (accountId) => {
    return `AccountUsersFilter:${accountId}`
  },

  AccountUsersFilter: (accountId, userId) => {
    return `AccountUsersFilter:${accountId}:${userId}`
  },

  Alerts: (accountId) => {
    return `Alerts:${accountId}`
  },

  AlertsFilter: (accountId) => {
    return `AlertsFilter:${accountId}`
  },

  AlertDueInDays: function () {
    return 'AlertDueInDays'
  },

  AlertDuePastDays: function () {
    return 'AlertDuePastDays'
  },

  AlertRepeatIntervalDays: function () {
    return 'AlertRepeatIntervalDays'
  },

  AlertRules: (projectId) => {
    return `AlertRules:${projectId}`
  },

  // AllLoans: (openOrClosed) => {
  //   return `AllLoans:${openOrClosed}`
  // },

  AllLoans: (openOrClosed, stp) => {
    return `AllLoans:${openOrClosed}:${stp}`
  },

  AccountFiles: (accountId) => {
    return `AccountFiles:${accountId}`
  },

  AccountLoans: (accountId) => {
    return `AccountLoans:${accountId}`
  },

  AllRemarks: () => {
    return `AllRemarks`
  },

  AllRepayments: (type, year, month) => {
    return `AllRepayments:${type}:${year}:${month}`
  },

  EMITracker2: (year, month, stp, allocation = '') => {
    return `EMITracker2:${year}:${month}:${stp}:${allocation}`
  },

  Amortizations: (loanId) => {
    return `Amortizations:${loanId}`
  },

  BankAccounts: (accountId) => {
    return `BankAccounts:${accountId}`
  },

  BankAccounts2: (accountId) => {
    return `BankAccounts2:${accountId}`
  },

  BankAccountMonths: (bankAccountNumber) => {
    return `BankAccountMonths:${bankAccountNumber}`
  },

  BankAnalyzerCategories: () => {
    return 'BankAnalyzerCategories'
  },

  BankTxns: (accountId) => {
    return `BankTxns:${accountId}`
  },

  BankTxnsFilter: (accountId) => {
    return `BankTxnsFilter:${accountId}`
  },

  Bills: (accountId) => {
    return `Bills:${accountId}`
  },

  BillsByLoanId: (loanId) => {
    return `BillsByLoanId:${loanId}`
  },

  ALMReport: (currentDateISO) => {
    return currentDateISO ? `ALMReport:${currentDateISO}` : 'ALMReport'
  },

  ALMBucketing: (currentDateISO) => {
    return currentDateISO ? `ALMReport:${currentDateISO}` : 'ALMReport'
  },

  Buckets: () => {
    return `Buckets`
  },

  Budget: (budgetId) => {
    return `Budget:${budgetId}`
  },

  BudgetItems: (budgetId) => {
    return `BudgetItems:${budgetId}`
  },

  BudgetItemsFilter: (budgetId) => {
    return `BudgetItemsFilter:${budgetId}`
  },

  Budgets: (accountId) => {
    return `Budgets:${accountId}`
  },

  BudgetsFilter: (accountId) => {
    return `BudgetsFilter:${accountId}`
  },

  CardTxns: (accountId) => {
    return `CardTxns:${accountId}`
  },

  CardTxnsFilter: (accountId) => {
    return `CardTxnsFilter:${accountId}`
  },

  CashFlows: (accountId) => {
    return `CashFlows:${accountId}`
  },

  CaptchaKey: 'CaptchaKey',

  ChargeValueITR: (accountId) => {
    return `ChargeValueITR:${accountId}`
  },

  ChargeValueMCA: (accountId) => {
    return `ChargeValueMCA:${accountId}`
  },

  ChartOfAccounts: function () {
    return 'ChartOfAccounts'
  },

  Chats: () => {
    return `Chats`
  },

  Chats: (status) => {
    return `Chats:${status}`
  },

  ChatMessages: (accountId) => {
    return `ChatMessages:${accountId}`
  },

  ChatMessages: (accountId, userId) => {
    return `ChatMessages:${accountId}:${userId}`
  },

  ChatMessages: (accountId, userId, status) => {
    return `ChatMessages:${accountId}:${userId}:${status}`
  },

  ChatUser: function () {
    return 'ChatUser'
  },

  CibilRanks: function () {
    return 'CibilRanks'
  },

  CreditReport: (accountId, userId) => {
    return `CreditReport:${accountId}:${userId}`
  },

  ClauseCodes: () => {
    return `ClauseCodes`
  },

  ClientBankAccounts: (accountId) => {
    return `ClientBankAccounts:${accountId}`
  },

  ClientTxnCategories: (accountId) => {
    return `ClientTxnCategories:${accountId}`
  },

  ClientTxnCats: (accountId) => {
    return `ClientTxnCats:${accountId}`
  },

  ClientTxnCatTxns: (accountId, category, financialYear) => {
    return `ClientTxnCatTxns:${accountId}:${category}:${financialYear}`
  },

  ClientTxnCatTxnsFilter: (accountId) => {
    return `ClientTxnCatTxnsFilter:${accountId}`
  },

  ClientTxnCashTxns: (accountId, category, year, month) => {
    return `ClientTxnCatTxns:${accountId}:${category}:${year}:${month}`
  },

  ClientTxnCashTxnsFilter: (accountId) => {
    return `ClientTxnCatTxnsFilter:${accountId}`
  },

  ClientTransactions: (bankAccountNumber, financialYear) => {
    return `ClientTransactions:${bankAccountNumber}:${financialYear}`
  },

  ClientTransactionsFilter: (bankAccountNumber) => {
    return `ClientTransactionsFilter:${bankAccountNumber}`
  },

  ClientWiseSummary: (accountNumber, year, month) => {
    return `ClientWiseSummary:${accountNumber}:${year}:${month}`
  },

  ComplianceReport: (year, month) => {
    return `ComplianceReport:${year}:${month}`
  },

  ComplianceTaskList: function () {
    return 'ComplianceTaskList'
  },

  ChequeBouncesList: (year, month) => {
    return `ChequeBouncesList:${year}:${month}`
  },

  ChequeBouncesListRetail: (year, month) => {
    return `ChequeBouncesListRetail:${year}:${month}`
  },

  CompList: function () {
    return 'CompList'
  },

  Contents: function (caller, locale) {
    return `Contents:${caller}:${locale}`
  },

  Countries: function () {
    return 'Countries'
  },

  CompanyReports: (accountId) => {
    return `CompanyReports:${accountId}`
  },

  ComplianceCodes: () => {
    return `ComplianceCodes`
  },

  CsStatus: () => {
    return `CsStatus`
  },

  CurrReconFailedTxns: (accountNumber) => {
    return `CurrReconFailedTxns:${accountNumber}`
  },

  Customers: (accountId) => {
    return `Customers:${accountId}`
  },

  CustomersFilter: (accountId) => {
    return `CustomersFilter:${accountId}`
  },

  CustomerInvoices: (accountId) => {
    return `CustomerInvoices:${accountId}`
  },

  CustomerInvoices: (customerId) => {
    return `CustomerInvoices:${customerId}`
  },

  DaysPastDues: () => {
    return `DaysPastDues`
  },

  DaysPastDues: (year, month) => {
    return `DaysPastDues:${year}:${month}`
  },

  Directors: (accountId) => {
    return `Directors:${accountId}`
  },

  Disbursements: (stp) => {
    return `Disbursements:${stp}`
  },

  Disbursements2: (stp) => {
    return `Disbursements2:${stp}`
  },

  DisbursementsMonthly: (stp) => {
    return `DisbursementsMonthly:${stp}`
  },

  DsraEvents: (accountId) => {
    return `DsraEvents:${accountId}`
  },

  DSRAReport: () => {
    return 'DSRAReport'
  },

  DSRAReport: (year, month) => {
    return `DSRAReport:${year}:${month}`
  },

  LendersReport: (stp) => {
    return `LendersReport:${stp}`
  },

  LendersReport: (year, month) => {
    return `LendersReport:${year}:${month}`
  },

  EscrowTxns: (accountNumber) => {
    return `EscrowTxns:${accountNumber}`
  },

  EscrowTxnsFilter: () => {
    return `EscrowTxnsFilter`
  },

  EventLogs: (accountId) => {
    return `EventLogs:${accountId}`
  },

  StandingInstructionLogs: (accountId) => {
    return `StandingInstructionLogs:${accountId}`
  },

  ExternalTxns: (accountNumber) => {
    return `ExternalTxns:${accountNumber}`
  },

  FDTxns: (accountNumber) => {
    return `FDTxns:${accountNumber}`
  },

  FileList: (loanId) => {
    return `FileList:${loanId}`
  },

  FixedDeposits: (accountNumber, financialYear) => {
    return `FixedDeposits:${accountNumber}:${financialYear}`
  },

  FreezeBankAnalyzer: (accountId) => {
    return `FreezeBankAnalyzer:${accountId}`
  },

  GSTReport: (accountId) => {
    return `GSTReport:${accountId}`
  },
  ChatFiles: (accountId) => {
    return `ChatFiles:${accountId}`
  },

  GSTReportMonthly: (accountId, gstNumber) => {
    return `GSTReportMonthly:${accountId}:${gstNumber}`
  },

  IdentityProvider: function (identity) {
    return `IdentityProvider:${identity}`
  },

  IncomeMonthly: (year, month) => {
    return `IncomeMonthly:${year}:${month}`
  },

  IncomeYearly: (financialYear) => {
    return `IncomeYearly:${financialYear}`
  },

  InterestRate: (accountId) => {
    return `InterestRate:${accountId}`
  },

  InventoryItems: (accountId) => {
    return `InventoryItems:${accountId}`
  },

  InventoryItemsFilter: (accountId) => {
    return `InventoryItemsFilter:${accountId}`
  },

  Invoice: (invoiceId) => {
    return `Invoice:${invoiceId}`
  },

  InvoiceItems: (invoiceId) => {
    return `InvoiceItems:${invoiceId}`
  },

  InvoiceItemsFilter: (invoiceId) => {
    return `InvoiceItemsFilter:${invoiceId}`
  },

  Invoices: (accountId, filter) => {
    return filter ? `Invoices:${accountId}:${filter}` : `Invoices:${accountId}`
  },

  InvoicesFilter: (accountId) => {
    return `InvoicesFilter:${accountId}`
  },

  ITRReport: (accountId) => {
    return `ITRReport:${accountId}`
  },

  KeyFinancials: (accountId) => {
    return `KeyFinancials:${accountId}`
  },

  Loans: (accountId) => {
    return `Loans:${accountId}`
  },

  LoansFilter: () => {
    return `LoansFilter`
  },

  Loan: (loanId) => {
    return `Loan:${loanId}`
  },

  LoanApr: (loanId) => {
    return `LoanApr:${loanId}`
  },

  DocumentRepository: (loanId) => {
    return `DocumentRepository:${loanId}`
  },

  LoanBankBalance: (accountId, withAccruedAmount) => {
    return `LoanBankBalance:${accountId}`
  },

  LoanBankBalanceCurrMonth: (accountId) => {
    return `LoanBankBalanceCurrMonth:${accountId}`
  },

  LoanCashFlow: (loanId) => {
    return `LoanCashFlow:${loanId}`
  },

  LoanDirectors: (loanId) => {
    return `LoanDirectors:${loanId}`
  },

  LoanFeasibility: (accountId) => {
    return `LoanFeasibility:${accountId}`
  },

   Leads: () => {
    return `Leads`
  },

  LeadDashboard: () => {
    return `LeadDashboard`
  },

  LeadDashboardEmailTemplates: () => {
    return `LeadDashboardEmailTemplates`
  },

  LoanMappings: (loanId) => {
    return `LoanMappings:${loanId}`
  },

  MappingGroup: (mappingGroup) => {
    return `MappingGroup:${mappingGroup}`
  },

  LoanProperties: (loanId) => {
    return `LoanProperties:${loanId}`
  },

  LoanRemarks: (loanId, objectCode) => {
    return `LoanRemarks:${loanId}:${objectCode}`
  },

  LoanRepayments: (accountId) => {
    return `LoanRepayments:${accountId}`
  },

  LoanStatements: (accountId) => {
    return `LoanStatements:${accountId}`
  },

  LoanSizing: (accountId) => {
    return `LoanSizing:${accountId}`
  },

  LoanSizingClassic: (loanId) => {
    return `LoanSizingClassic:${loanId}`
  },

  LoanSizingClassic2: (loanId) => {
    return `LoanSizingClassic2:${loanId}`
  },

  LoanSizingSmall: (loanId) => {
    return `LoanSizingSmall:${loanId}`
  },

  LoanSizingSmall2: (loanId) => {
    return `LoanSizingSmall2:${loanId}`
  },

  LoanSubTypeList: () => {
    return `LoanSubTypeList`
  },

  LoanTypeList: () => {
    return `LoanTypeList`
  },

  LoanCheck: (accountId) => {
    return `LoanCheck:${accountId}`
  },

  LoanTerms: (loanId) => {
    return `LoanTerms: ${loanId}`
  },

  LoanTypes: () => {
    return 'LoanTypes'
  },

  LoanTransactions: (loanId) => {
    return `LoanTransaction: ${loanId}`
  },

  Mappings: (mappingGroup) => {
    return `Mappings:${mappingGroup}`
  },

  Messages: function (caller, locale) {
    return `Messages:${caller}:${locale}`
  },

  MessageApprovals: (accountId, year, month) => {
    return `MessageApprovals:${accountId}:${year}:${month}`
  },


  JournalEntries: (accountId) => {
    return `JournalEntries:${accountId}`
  },
  NachFailures: (accountId, year, month) => {
    return `NachFailures:${accountId}:${year}:${month}`
  },

  NachMandates: (accountId) => {
    return `NachMandates:${accountId}`
  },

  NonCompliances: (accountId) => {
    return `NonCompliances:${accountId}`
  },

  MCAReport: (accountId) => {
    return `MCAReport:${accountId}`
  },

  MonthlyCashFlow: (bankAccountNumber) => {
    return `MonthlyCashFlow:${bankAccountNumber}`
  },

  MonthlyCompliances: (loanId) => {
    return `MonthlyCompliances:${loanId}`
  },

  MonthlySummaries: (accountId) => {
    return `MonthlySummaries:${accountId}`
  },

  MonthlyIncome: (year, month) => {
    return `MonthlyIncome:${year}:${month}`
  },

  MutualFunds: (accountNumber, financialYear) => {
    return `MutualFunds:${accountNumber}:${financialYear}`
  },

  MutualFundsTxns: (accountNumber) => {
    return `MutualFundsTxns:${accountNumber}`
  },

  NachReport: (year, month, stp) => {
    return `NachReport:${year}:${month}:${stp}`
  },

  NachMonthly: (yearMonth) => {
    return `NachMonthly:${yearMonth}`
  },

  NodalCashFlow: (accountNumber, startDate, endDate) => {
    return `NodalCashFlow:${accountNumber}:${startDate}:${endDate}`
  },

  NodalCFDateRange: () => {
    return 'NodalCFDateRange'
  },

  NodalTxns: (accountNumber, year, month) => {
    return `NodalTxns:${accountNumber}:${year}:${month}`
  },

  NodalTxnsFilter: () => {
    return `NodalTxnsFilter`
  },


  NonCompliance: (year, month) => {
    return `NonCompliance:${year}:${month}`
  },

  Compliances: (loanId, year, month) => {
    return `Compliances:${loanId}:${year}:${month}`
  },

  OptionLists: () => {
    return `OptionLists`
  },

  Order: (orderId) => {
    return `Order:${orderId}`
  },

  Orders: (accountId, filter) => {
    return filter ? `Orders:${accountId}:${filter}` : `Orders:${accountId}`
  },

  OrdersFilter: (accountId) => {
    return `OrdersFilter:${accountId}`
  },

  OrderBudgets: (orderId) => {
    return `OrderBudgets:${orderId}`
  },

  OrderBudgetsFilter: (orderId) => {
    return `OrderBudgetsFilter:${orderId}`
  },

  OrderInvoices: (orderId) => {
    return `OrderInvoices:${orderId}`
  },

  OrderInvoicesFilter: (orderId) => {
    return `OrderInvoicesFilter:${orderId}`
  },

  OrderItems: (orderId) => {
    return `OrderItems:${orderId}`
  },

  OrderItemsFilter: (orderId) => {
    return `OrderItemsFilter:${orderId}`
  },

  OrderItemStatuses: () => {
    return 'OrderItemStatuses'
  },

  OrderStatuses: () => {
    return 'OrderStatuses'
  },

  OutOfPocketExpenses: (loanId) => {
    return `OutOfPocketExpenses:${loanId}`;
  },

  PaidRepayments: (year, month) => {
    return `PaidRepayments:${year}:${month}`
  },

  PANGSTList: (panNumber) => {
    return `PANGSTList:${panNumber}`
  },

  Payables: (accountId) => {
    return `Payables:${accountId}`
  },

  PaymentCards: (accountId) => {
    return `PaymentCards:${accountId}`
  },

  PaymentMethods: (accountId) => {
    return `PaymentMethods:${accountId}`
  },

  PDFDocuments: () => {
    return 'PDFDocuments'
  },

  PaymentCard: (accountId, userId) => {
    return `PaymentCard:${accountId}:${userId}`
  },

  Penalty: (year, month) => {
    return `Penalty:${year}:${month}`
  },

  PendingMessageApprovals: (year, month) => {
    return `PendingMessageApprovals:${year}:${month}`
  },

  PendingTxns: () => {
    return 'PendingTxns'
  },

  DailyPaymentsReport: (dateISO) => {
    return `DailyPaymentsReport:${dateISO}`
  },

  PendingTxnsFilter: () => {
    return `PendingTxnsFilter`
  },

  Permissions: (accountId, userId) => {
    return `Permissions:${accountId}:${userId}`
  },

  Prepayment: (loanId) => {
    return `Prepayment:${loanId}`
  },

  Prices: (caller, countryCode, locale) => {
    return `Prices:${caller}:${countryCode}:${locale}`
  },

  Pricing: (countryCode, locale) => {
    return `Pricing:${countryCode}:${locale}`
  },

  ProcessingFees: () => {
    return `ProcessingFees`
  },

  ProcessingFees2: (financialYear) => {
    return `ProcessingFees2:${financialYear}`
  },

  ProductItems: (accountId) => {
    return `ProductItems:${accountId}`
  },

  ProjectByLoanId: (loanId) => {
    return `ProjectByLoanId:${loanId}`
  },

  Properties: () => {
    return 'Properties'
  },

  ProjectPub: (projectId) => {
    return `ProjectPub:${projectId}`
  },

  Project: (projectId) => {
    return `Project:${projectId}`
  },

  Projects: (accountId) => {
    return `Projects:${accountId}`
  },

  ProjectsFilter: (accountId) => {
    return `ProjectsFilter:${accountId}`
  },

  ProjectStatuses: () => {
    return 'ProjectStatuses'
  },

  ProjectTypes: () => {
    return 'ProjectTypes'
  },

  ProjectUsers: (projectId) => {
    return `ProjectUsers:${projectId}`
  },

  ProjectUsersFilter: (projectId) => {
    return `ProjectUsersFilter:${projectId}`
  },

  ProjectVisibilities: () => {
    return 'ProjectVisibilities'
  },

  ReconFailedBankTxns: (accountNumber) => {
    return `ReconFailedBankTxns:${accountNumber}`
  },

  ReconFailedTxns: (accountNumber) => {
    return `ReconFailedTxns:${accountNumber}`
  },

  ReconTxns: (accountNumber, year, month) => {
    return `ReconTxns:${accountNumber}:${year}:${month}`
  },

  ReferenceProjectsByLoanId: (loanId) => {
    return `ReferenceProjectsByLoanId:${loanId}`
  },

  ReceivableFinancing: (accountId) => {
    return `ReceivableFinancing:${accountId}`
  },

  Repayments: (loanId) => {
    return `Repayments:${loanId}`
  },

  RepaymentsInitiated: () => {
    return `RepaymentsInitiated`
  },

  RepaymentsInitFilter: () => {
    return 'RepaymentsInitFilter'
  },

  StandingInstructionsReport: () => {
    return `StandingInstructionsReport`
  },

  RfTransactions: (accountId) => {
    return `RfTransactions:${accountId}`
  },

  RiskRegisters: (year, month) => {
    return `RiskRegisters:${year}:${month}`
  },

  Roles: function (group, locale) {
    return `Roles:${group}:${locale}`
  },

  SalesChannel: () => {
    return `SalesChannel`
  },

  SalesContactList: () => {
    return `SalesContactList`
  },

  SalesTargetList: (month, channel, originator) => {
    return `SalesTargetList:${month}:${channel}:${originator}`
  },

  SalesReportList: () => {
    return `SalesReportList`
  },

  S3Objects: (bucketName) => {
    return `S3Objects:${bucketName}`
  },

  S3Objects: (bucket, folder) => {
    return `S3Objects:${bucket}:${folder}`
  },

  S3ObjectVersions: (bucketName, folderName, objectId) => {
    return `S3ObjectVersions:${bucketName}:${folderName}:${objectId}`
  },

  ScheduledTasks: (accountId) => {
    return `ScheduledTasks:${accountId}`
  },

  ScoreParameters: (accountId) => {
    return `ScoreParameters:${accountId}`
  },

  ScoreCards: (accountId) => {
    return `ScoreCards:${accountId}`
  },

  Sectors: () => {
    return `Sectors`
  },

  SelectedCustomer: () => {
    return 'SelectedCustomer'
  },

  SelectedYearMonth: 'SelectedYearMonth',

  SocialLoginUrl: 'SocialLoginUrl',

  SOA: (accountId) => {
    return `SOA:${accountId}`
  },

  Strings: function (caller, locale) {
    return `Strings:${caller}:${locale}`
  },

  Subscription: (accountId) => {
    return `Subscription:${accountId}`
  },

  SupportOwnerUsers: () => {
    return 'SupportOwnerUsers'
  },

  StripeApiKey: function () {
    return 'StripeApiKey'
  },

  SuperUsers: function () {
    return 'SuperUsers'
  },

  SuperUserAppOnboardingStatus: function () {
    return 'SuperUserAppOnboardingStatus'
  },

  State: function () {
    return 'state'
  },

  SubservientITR: (accountId) => {
    return `SubservientITR:${accountId}`
  },

  SubservientMCA: (accountId) => {
    return `SubservientMCA:${accountId}`
  },

  SupportTemplates: function () {
    return 'SupportTemplates'
  },

  SystemGeneratedProperties: (loanId) => {
    return `SystemGeneratedProperties:${loanId}`
  },

  TokenDocTypeFilter: (loanId) => {
    return `TokenDocTypeFilter:${loanId}`
  },

  TaskLogs: (taskId) => {
    return `TaskLogs:${taskId}`
  },

  TaskMessages: (taskId) => {
    return `TaskMessages:${taskId}`
  },

  TaskMessageUsers: (taskId) => {
    return `TaskMessageUsers:${taskId}`
  },

  TaskPriorities: () => {
    return 'TaskPriorities'
  },

  TaskPriorities2: () => {
    return 'TaskPriorities2'
  },

  TaskStatuses: () => {
    return 'TaskStatuses'
  },

  TaskUsers: (taskId) => {
    return `TaskUsers:${taskId}`
  },

  TaskTree: (projectId) => {
    return `TaskTree:${projectId}`
  },

  TasksFilter: (projectId) => {
    return `TasksFilter:${projectId}`
  },

  TasksUnfolded: (projectId) => { // list of taskIds
    return `TasksUnfolded:${projectId}`
  },

  TaskIdCurrent: (projectId) => {
    return `TaskIdCurrent:${projectId}`
  },

  TdsTypes: function () {
    return 'tdsTypes'
  },

  TestAccounts: () => {
    return `TestAccounts`
  },

  Templates: (templateCode) => {
    return `Templates:${templateCode}`
  },

  Templates: (loanId, templateCode) => {
    return `Templates:${loanId}:${templateCode}`
  },

  TermSheetScheduleRows: (loanId) => {
    return `TermSheetScheduleRows:${loanId}`
  },

  TransactionTypes: () => {
    return `TransactionTypes`
  },

  Transaction: (applFeeTxnId) => {
    return `Transactions:${applFeeTxnId}`
  },

  Transactions: (accountId, bankAccountNumber) => {
    return `Transactions:${accountId}:${bankAccountNumber}`
  },

  TxnsDaily: (currentDate) => {
    return `Transactions:${currentDate}`
  },

  TransactionsFilter: (accountId, bankAccountNumber) => {
    return `TransactionsFilter:${accountId}:${bankAccountNumber}`
  },

  Transactions2: (accountId, bankAccountNumber, year, period) => {
    return `Transactions2:${accountId}:${bankAccountNumber}:${year}:${period}`
  },

  Transactions2Filter: (accountId, bankAccountNumber) => {
    return `Transactions2Filter:${accountId}:${bankAccountNumber}`
  },

  Triangulations: (accountId) => {
    return `Triangulations:${accountId}`
  },

  Triangulations: (accountId, fromYearMonth, toYearMonth) => {
    return `Triangulations:${accountId}:${fromYearMonth}:${toYearMonth}`
  },

  TriangulationNMonths: (accountId, lastNMonths, showGstData) => {
    return `TriangulationNMonths:${accountId}:${lastNMonths}:${showGstData}`
  },

  TriangulationNMonths: (accountId, fromYearMonth, toYearMonth, showGstData) => {
    return `TriangulationNMonths:${accountId}:${fromYearMonth}:${toYearMonth}:${showGstData}`
  },

  Triangulation6Months: (accountId) => {
    return `Triangulation6Months:${accountId}`
  },

  TriangulationFromApril: (accountId) => {
    return `TriangulationFromApril:${accountId}`
  },

  NetCashFlow: (accountId, dateRange) => {
    return `NetCashFlow:${accountId}:${dateRange || 'ytd'}`
  },

  UnPaidRepayments: (year, month) => {
    return `UnPaidRepayments:${year}:${month}`
  },

  User: function (userId) {
    return `User:${userId}`
  },

  User: (accountId, userId) => {
    return `User:${accountId}:${userId}`
  },

  Users: () => {
    return `Users`
  },

  UserS: () => {
    return `UserS`
  },

  OwnerUsers: () => {
    return 'OwnerUsers'
  },

  VehicleType: () => {
    return 'VehicleType'
  },

  VehicleTypeList: () => {
    return 'VehicleTypeList'
  },

  Vendors: (accountId) => {
    return `Vendors:${accountId}`
  },

  VendorsFilter: (accountId) => {
    return `VendorsFilter:${accountId}`
  },

  VendorBills: (accountId) => {
    return `VendorBills:${accountId}`
  },

  VendorBillsFilter: (accountId) => {
    return `VendorBillsFilter:${accountId}`
  },

  EscrowAccounts: () => {
    return `EscrowAccounts`
  },

  Years: () => {
    return `Years`
  },

  ZybraCustomerList: () => {
    return `ZybraCustomerList`
  },

  FailedExternalApiCalls: (lastEvaluatedKey) => {
    return `FailedExternalApiCalls:${lastEvaluatedKey || 'initial'}`
  },

  ExternalDataCache: (lastEvaluatedKey) => {
    return `ExternalDataCache:${lastEvaluatedKey || 'initial'}`
  },

  RepeatTransactionEligibility: () => {
    return 'RepeatTransactionEligibility'
  },

  RepeatTransactionOffers: (page) => {
    return page ? `RepeatTransactionOffers:${page}` : 'RepeatTransactionOffers'
  },

  PreApprovedLoansEligibility: () => {
    return 'RepeatTransactionEligibility'
  },

  OnBoardingDocs: (accountId) => {
    return `OnBoardingDocs:${accountId}`
  },

  ProvisionalFinancials: (accountId) => {
    return `ProvisionalFinancials:${accountId}`
  },

}

export default CacheKeys
